export default __webpack_public_path__ + "static/media/biz-dash-templates.5b54a88d.png";